import React from 'react';
import styled from 'styled-components/macro';
import {
  ActionsTitleText,
  TicketPaginationText,
  lowHeightScreens,
  mediumScreens,
  smallScreens,
  HeaderText as FontElementHeaderText,
} from '../../common/fontElements';
import * as colors from '../../common/colorConstants';

export const ResultsHeader = styled(FontElementHeaderText)`
  display: ${(props) => (props.hide ? 'none' : 'inline')};
`;

export const ResultsCancelSubscriptionHeader = styled.thead`
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  color: #7f7f7f !important;
`;

export const ResultRow = styled.tr`
  color: #000;
  cursor: ${(props) => (props.autoCursor ? 'auto' : 'pointer')};
  border-bottom: 0.1rem solid #d8e8ef;

  & em {
    background-color: #a1b6a7;
    color: #fff;
    font-style: normal;
  }

  & td {
    padding: 8px;
    line-height: 1.42857;
    vertical-align: top;
  }

  ${(props) =>
    !props.autoCursor &&
    `&:hover {
    color: #7f7f7f;
  }`};
`;

ResultRow.displayName = 'ResultRow';

export const ResultPageWrapper = styled.div`
  height: 100%;
  overflow-y: scroll;
  display: grid;
  grid-template-rows: 1fr, min-content;
  background-color: ${colors.baseBackground};
  position: relative;
`;

ResultPageWrapper.displayName = 'ResultPageWrapper';

export const ResultPageContent = styled.div`
  background-color: ${colors.baseBackground};
  padding: 20px 0;
  width: 100%;
  margin: 0 auto;
`;

ResultPageContent.displayName = 'ResultPageContent';

export const Header = styled.div`
  display: flex;
  padding: 0 20px;
  flex-direction: row;
  margin-bottom: 20px;
`;

Header.displayName = 'Header';

export const HeaderText = styled(ActionsTitleText)`
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  line-height: 1.14;
  letter-spacing: normal;
  color: #3d3d63;
`;

const BackButtonHolder = styled.div`
  height: 100%;
  padding: 0 10px 2px;
  display: flex;
  align-self: center;
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')};
`;

export const BackButton = (props) => (
  <BackButtonHolder {...props}>
    <img src="/images/curved-back-arrow.svg" alt="back-button" />
  </BackButtonHolder>
);

export const ResultPaginationSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: sticky;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: ${colors.baseBackground};
`;

export const PaginationButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 22px;
  width: 112px;
  border: solid 1px #154d57;
  border-radius: 6px;
  padding: 0 7px;
  background: ${colors.baseBackground};
  margin: 15px 0px;
`;

export const PaginationArrow = styled.img`
  height: 11px;
  width: 11px;
  cursor: pointer;
  visibility: ${(props) => (props.hide ? 'hidden' : 'visibile')};
`;

export const PaginationText = styled(TicketPaginationText)`
  display: inline-block;
  color: #154d57;
  background: ${colors.baseBackground};
`;

export const SearchAsk = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid ${colors.lightGray10};
  height: 25px;
  flex: 1;
  border-radius: 3px;
  color: ${colors.lightGray2};
  background: ${colors.lightGray10};
  margin-bottom: ${(props) => (props.addBottomPadding ? '15px' : '0px')};
`;

export const SearchInputText = styled.input`
  outline: none;
  resize: none;
  overflow: auto;
  border: none;
  flex: 8;
  height: 25px;
  margin: 0px 5px;
  padding: 0;
  font-family: Lato, sans-serif;
  font-weight: bold;
  font-size: 12px;
  color: ${colors.lightGray2};
  background: ${colors.lightGray10};

  ::placeholder {
    color: rgba(45, 45, 45, 0.31);
  }

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const SearchImageLeft = styled.div`
  width: ${(props) => (props.hide ? '0' : '20px')};
  justify-content: flex-end;
  display: flex;
  margin-top: 2px;
  margin-left: 8px;

  img {
    width: 15px;
  }
`;

export const SearchImageRight = styled.div`
  width: 15px;
  cursor: pointer;
  margin-right: 9px;
  display: flex;
  align-items: center;
`;
